import React from "react";
import "./About.css";

// Import image
import aboutImg from "../images/sikkim.png";

// Icons (you can replace with real icons later)
import icon1 from "../images/icon1.png";
import icon2 from "../images/icon2.png";
import icon3 from "../images/icon3.png";
import icon4 from "../images/icon4.png";

const About = () => {
  return (
    <>
      {/* ABOUT SECTION */}
      <section className="about">
        <div className="about-container">
          
          {/* Left Image */}
          <div className="about-image">
            <img src={aboutImg} alt="Sikkim" />
          </div>

          {/* Right Content */}
          <div className="about-content">
            <h2>ABOUT SIKKIM</h2>
            <p>
              <b>Sikkim</b> is a small yet incredibly beautiful state located in the northeastern part of India. Surrounded by the <b>majestic Himalayas</b>, it is famous for its natural beauty, peaceful environment, and rich cultural heritage.
            </p>

            <p>
              Nestled in the Himalayas, Sikkim offers stunning views of <b>Kangchenjunga</b>, <b>the highest mountain in India</b> and <b>the third-highest mountain in the world</b>. Covered with snow throughout the year, it is considered sacred by the people of the state and adds breathtaking beauty to the Himalayan landscape.

Tourists are attracted to serene lakes like <b>Tsomgo Lake</b>, vibrant monasteries such as <b>Rumtek Monastery</b>, and <b>colorful local festivals</b>. Sikkim is also blessed with beautiful mountain peaks like <b>Mount Pandim, Mount Kabru, Mount Siniolchu</b>, and <b>Mount Narsing</b>, which are known for their scenic beauty and trekking opportunities.
            </p>
            <p>From adventure activities like <b>trekking, river rafting,</b> and <b>mountain biking</b> to peaceful experiences in nature, Sikkim has something for every traveler. The clean environment, friendly locals, and well-preserved culture make it a perfect destination for both relaxation and exploration.</p>
          </div>

        </div>
      </section>

      {/* FEATURES SECTION */}
      <section className="features">
        <h2>WE ARE BEST FOR</h2>

        <div className="features-container">

          <div className="feature-card">
            <img src={icon1} alt="" />
            <h3>AFFORDABLE LUXURY</h3>
            <p>
              Enjoy the perfect balance of budget-friendly comfort and premium travel experiences for every journey.
            </p>
          </div>

          <div className="feature-card">
            <img src={icon2} alt="" />
            <h3>LOCAL CULTURE</h3>
            <p>
              Experience the true essence of Sikkim through its rich traditions, local lifestyle, and cultural heritage.
            </p>
          </div>

          <div className="feature-card">
            <img src={icon3} alt="" />
            <h3>FLEXIBLE TRAVEL</h3>
            <p>
              Solo, family, or in a group, we provide customized solutions for every type of journey.
            </p>
          </div>

          <div className="feature-card">
            <img src={icon4} alt="" />
            <h3>24/7 SUPPORT</h3>
            <p>
              Get expert travel assistance anytime, ensuring a guided and worry-free travel experience throughout your journey.
            </p>
          </div>

        </div>
      </section>
    </>
  );
};

export default About;